<footer class="app-footer">
  <div class="app-footer__inner">
    <div class="app-footer__brand">
      <svg width="22" height="22" viewBox="0 0 44 44" fill="none">
        <defs>
          <linearGradient id="bagGrad" x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
            <stop stop-color="#3E79CE" />
            <stop offset="1" stop-color="#699F53" />
          </linearGradient>
        </defs>
        <path
          d="M9 19 C8.4 19 7.9 19.5 7.8 20.1 L6.2 38 Q6.1 39.5 7.6 39.5 L36.4 39.5 Q37.9 39.5 37.8 38 L36.2 20.1 C36.1 19.5 35.6 19 35 19 Z"
          fill="url(#bagGrad)" />
        <path d="M16.5 19 C16.5 12 27.5 12 27.5 19" stroke="url(#bagGrad)" stroke-width="2.5" fill="none"
          stroke-linecap="round" />
        <path d="M15 29.5 L20.5 35 L30 23" stroke="white" stroke-width="2.8" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <span>PickMeRight</span>
    </div>

    <nav class="app-footer__links">
      <a *ngFor="let link of footerLinks" [routerLink]="link.route">{{ link.label }}</a>
    </nav>

    <div class="app-footer__copy"> Copyright © {{ currentYear }} Technoreach Labs. All rights reserved.</div>
  </div>
</footer>